export default "__VITE_ASSET__7ee0b988__"